globalThis.Dialogue = class Dialogue extends Card {
  constructor(options = {}) {
    options.title = options.title || "Confirmation";
    super(options);
    globalThis.DIALOGUE?.remove();
    globalThis.DIALOGUE = this;
    this.action = options.action;
    this.div.classList.add("dialogue");
    this.body = document.createElement("p");
    this.body.innerText = options.body ?? "Are you sure?";
    const buttons = document.createElement("div");
    if (options.closable !== false) {
      this.cancel = document.createElement("button");
      this.cancel.classList.add("cancel");
      this.cancel.innerText = options.cancelText || "Cancel";
      this.cancel.addEventListener("click", this.remove.bind(this), this.abort);
      buttons.append(this.cancel);
    }
    this.ok = document.createElement("button");
    this.ok.classList.add("ok");
    this.ok.innerText = options.okText || "OK";
    this.ok.addEventListener("click", this.onOK.bind(this), this.abort);
    buttons.append(this.ok);
    this.content.append(this.body, buttons);
    addEventListener("keydown", this.onKeydown.bind(this), this.abort);
  }

  remove() {
    super.remove();
    delete globalThis.DIALOGUE;
  }

  onOK() {
    if (this.action) this.action.call(this) || this.remove();
    else this.remove();
  }

  onKeydown(event) {
    if (event.keyCode === 27) this.remove();
  }
};
